import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { WhatsAppChatHeader, WhatsAppChatModel, WhatsAppDetailModel } from '../../../business-entities/whatsapp-chat.model';
import { WhatsAppLogAddModel } from '../../../business-entities/whatsapp-log-add-model';
import { WhatsAppLogService } from '../../../business-services/whatsapp-log.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WhatsAppStatus } from '../../../business-entities/whatsapp-status-model';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-whatsapp-messages',
  templateUrl: './whatsapp-messages.component.html',
  styleUrls: ['./whatsapp-messages.component.css']
})
export class WhatsAppMessagesComponent implements OnInit {
  public whatsAppChats: WhatsAppChatModel;
  message: string='';
  hidePlaceholder: boolean = false;
  @Input() appointmentId: number;
  @Input() customerName: string;
  @Input() customerContactNo: string;
  contactNo:string = EnvSetting.whatsappContactNo

  constructor(private activeModal: NgbActiveModal,
    private whatsAppLogService: WhatsAppLogService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private cdref: ChangeDetectorRef,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.setChatHeader();
    this.getMessages();
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  setChatHeader() {
    let chatHeader = new WhatsAppChatHeader();
    chatHeader.adminImage = "/assets/images/bnh/favicon.ico";
    chatHeader.customerImage = "/assets/img/user-logo.png";
    chatHeader.customerName = this.customerName;
    chatHeader.customerNo = this.customerContactNo;
    this.whatsAppChats = new WhatsAppChatModel();
    this.whatsAppChats.chatHeader = chatHeader;
  }

  getMessages() {
    this.spinner.show();
    this.whatsAppLogService.getMessages(this.appointmentId).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.whatsAppChats.chatDetail = res.responseObject;
      }
    }).catch(_err => {
      console.log(_err);
    }).finally(() => {
      this.spinner.hide();
    });
  }

  refreshChat() {
    this.clearSendMessage();
    this.getMessages();
  }

  sendMessage() {
    this.customerContactNo = this.contactNo;//for sandbox testing

    if (!this.validateSendMessage()) {
      return;
    }

    const whatsAppLogAdd = new WhatsAppLogAddModel();
    whatsAppLogAdd.appointmentId = this.appointmentId;
    whatsAppLogAdd.whatsAppTo = this.customerContactNo;
    whatsAppLogAdd.whatsAppMessage = this.message;

    this.addNewChatDetail();
    this.clearSendMessage();

    this.whatsAppLogService.sendMessage(whatsAppLogAdd).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.whatsAppChats.chatDetail[this.whatsAppChats.chatDetail.length - 1].whatsAppStatus = res.responseObject;
      }
    }).catch(_err => {
      console.log(_err);
    });
  }

  private validateSendMessage(): boolean {
    if (!this.customerContactNo.trim()) {
      this.toastr.error("Customer contact number is required to send message");
      return false;
    }
    else if (!this.message.trim()) {
      this.toastr.error("Please write a message to send message");
      return false;
    }

    return true;
  }

  private addNewChatDetail() {
    let chatDetail = new WhatsAppDetailModel();
    chatDetail.whatsAppMessage = this.message;
    chatDetail.whatsAppStatus = WhatsAppStatus.Queued;
    chatDetail.createdDate = new Date();
    chatDetail.seqNo = this.getNewChatSeqNo(chatDetail.createdDate);
    this.whatsAppChats.chatDetail.push(chatDetail);
  }

  private getNewChatSeqNo(createdDate: Date) {
    if (this.whatsAppChats?.chatDetail && this.whatsAppChats?.chatDetail.length > 0) {
      let latestChat = this.whatsAppChats.chatDetail[this.whatsAppChats.chatDetail.length - 1];
      let latestChatDate = this.datePipe.transform(latestChat.createdDate, 'dd/MM/yyyy');
      let newChatDate = this.datePipe.transform(createdDate, 'dd/MM/yyyy');

      if (newChatDate === latestChatDate) {
        return latestChat.seqNo + 1;
      }
    }

    return 1;
  }

  clearSendMessage() {
    this.message = '';
  }

  OnClose() {
    this.activeModal.close({ success: false });
  }
}
